import _ from 'lodash';
import { createSelector } from 'reselect';
import moment from 'moment';

export const minDateForActiveOrders = moment().subtract(14, 'd');

export const getWorkOrders = state => state.customer.profile.workOrders.ordersList;
export const getActiveWorkOrder = state => state.customer.profile.workOrders.activeOrder;
export const getPreviousWorkOrder = state => state.customer.profile.workOrders.previousOrder;
export const getSelectedTabName = state => state.customer.profile.workOrders.selectedTabName;
export const isLoading = state => state.customer.profile.workOrders.isLoading;

export const getActiveWorkOrdersList = orders => _.filter(orders, order => (!moment(order.registeredDateTime, 'YYYY-MM-DD').isBefore(minDateForActiveOrders)));
export const getPreviousWorkOrdersList = orders => _.filter(orders, order => (moment(order.registeredDateTime, 'YYYY-MM-DD').isBefore(minDateForActiveOrders)));

export const getNewestWorkOrder = state => _.find(state.customer.profile.workOrders.ordersList, order => _.min(order.registeredDateTime));